// Pin a table onto Canvas, or a folder onto Quick Docs. Never used on Tasks.
import type { JSX } from 'preact';
import { useState } from 'preact/hooks';
import { starItem, unstarItem, useFavorites } from '../lib/favorites';

export function FavoriteStar({ itemKey }: { itemKey: string }): JSX.Element | null {
  const data = useFavorites();
  const [busy, setBusy] = useState(false);
  if (data.status !== 'ready' || !Array.isArray(data.data?.catalog)) return null;
  const catalogItem = data.data.catalog.find((item) => item.item_key === itemKey);
  if (!catalogItem) return null;

  const hit = data.data.favorites.find((f) => f.item_key === itemKey) ?? null;
  const on = hit !== null;
  const dest = catalogItem.kind === 'folder'
    ? 'Quick Docs'
    : catalogItem.kind === 'person' ? 'People' : 'Canvas';
  const label = on ? `Remove from ${dest}` : `Pin to ${dest}`;

  return (
    <button
      type="button"
      class={on ? 'fav-star on' : 'fav-star'}
      data-testid={`fav-star-${itemKey}`}
      aria-pressed={on}
      aria-label={label}
      title={label}
      disabled={busy}
      onClick={() => {
        setBusy(true);
        const work = on && hit ? unstarItem(hit.id) : starItem(itemKey);
        void work.finally(() => setBusy(false));
      }}
    >
      <i aria-hidden="true" />
    </button>
  );
}
